import {Path} from "../pages/public/path";
import Icon from '@ant-design/icons';
import React from "react";
import {ReactComponent as CustomerIcon} from '../images/layout/nav_customer.svg'
import {ReactComponent as FissionIcon} from '../images/layout/nav_fission.svg'
import {ReactComponent as MarketIcon} from '../images/layout/nav_market.svg'
import {ReactComponent as AssertIcon} from '../images/layout/nav_assert.svg'
import {ReactComponent as MarketSettingIcon} from '../images/layout/nav_market_setting_1.svg'
import {ReactComponent as DrainageIcon} from '../images/layout/drainage.svg'

const NavConfig = [
    {
        title: '引流获客',
        key: 'drainage',
        isOpen: 'true',
        icon: < Icon component={DrainageIcon}/>,
        submenu: [
            {
                title: '渠道活码',
                path: Path.getChannelCodeWords(),
                pathIn: Path.isFissionChannel
            },
            // {
            //     title: '引流链接',
            //     path: Path.getDrainageLinks(),
            //     pathIn: Path.isDrainageLinks
            // }
        ]
    },
    {
        title: '裂变获客',
        key: 'fission',
        isOpen: 'true',
        icon: < Icon component={FissionIcon}/>,
        submenu: [
            {
                title: '客户裂变',
                path: Path.getFissionCustomer(),
                pathIn: Path.isFissionCustomer
            },
            {
                title: '社群裂变',
                path: Path.getFissionChat(),
                pathIn: Path.isFissionChat
            },
            {
                title: '红包获客',
                path: Path.getFissionRedpacket(),
                pathIn: Path.isFissionRedpacket
            },
            {
                title: '红包扩群',
                path: Path.getFissionGroupRed(),
                pathIn: Path.isFissionGroupRed
            },
            {
                title: '抽奖裂变',
                path: Path.getFissionLottery(),
                pathIn: Path.isFissionLottery
            }
        ]
    },
    {
        title: '营销中心',
        key: 'market',
        isOpen: 'true',
        icon: < Icon component={MarketIcon}
        />,
        submenu: [
            {
                title: '分销系统',
                path: Path.getMarketDistri(),
                pathIn: Path.isMarketDistri
            },
            {
                title: '拼团系统',
                path: Path.getMarketGroupbuy(),
                pathIn: Path.isMarketGroupbuy
            },
            {
                title: '一元解锁',
                path: Path.getMarketPrizeUnlock(),
                pathIn: Path.isMarketPrizeUnlock
            },
            {
                title: '表单管理',
                path: Path.getMarketForm(),
                pathIn: Path.isMarketForm
            },
            {
                title: '兑换码',
                path: Path.getMarketRedeemCode(),
                pathIn: Path.isMarketRedeemCode
            },
            {
                title: '核销管理',
                path: Path.getMarketVerifier(),
                pathIn: Path.isMarketVerifier
            },
            {
                title:'批量发货',
                path: Path.getBatchDeliver(),
                pathIn: Path.isGetBatchDeliver
            }
        ]
    },
    {
        title: '客户管理',
        key: 'customer',
        isOpen: 'true',
        icon: < Icon component={CustomerIcon}
        />,
        submenu: [{
            title: '客户管理',
            path: Path.geCustomerMange(),
            pathIn: Path.isCustomerMange
        },
            {
                title: '黑名单',
                path: Path.getCustomerBlackList(),
                pathIn: Path.isCustomerBlackList
            },
            {
                title: '客户标签',
                path: Path.getCustomerTag(),
                pathIn: Path.isCustomerTag
            },
        ]
    },
    {
        title: '资产管理',
        key: 'marketAssert',
        isOpen: 'true',
        icon: < Icon component={AssertIcon}
        />,
        submenu: [{
            title: '我的账户',
            path: Path.goMarketAssets(),
            pathIn: Path.isMarketAssets
        },
            {
                title: '结算记录',
                path: Path.gotoAssetSettle() + 1,
                pathIn: Path.isMarketAssetsSettle
            },
            {
                title: '提现管理',
                path: Path.goMarketAssetsWithdraws(),
                pathIn: Path.isMarketAssetsWithdraws
            },
            {
                title: '账单明细',
                path: Path.goMarketAssetsStatements(),
                pathIn: Path.isMarketAssetsStatements
            },
            {
                title: '日对账单',
                path: Path.goMarketAssetsSummary(),
                pathIn: Path.isMarketAssetsSummary

            }
        ]
    },
    {
        title: '配置管理',
        key: 'marketSetting',
        isOpen: 'true',
        icon: < Icon component={MarketSettingIcon}
        />,
        submenu: [
            {
                title: '营销配置',
                path: Path.getMarketConfigBrand(),
                pathIn: Path.isMarketConfig
            },
            {
                title: '公众号',
                path: Path.getMpConfig(),
                pathIn: Path.isMpConfig
            },
            {
                title: '支付配置',
                path: Path.getWxPayConfig(),
                pathIn: Path.isWxPayConfig
            },
            {
                title: '企业微信',
                path: Path.getCorpManageConfig(),
                pathIn: Path.isCorpManageConfig
            },
            {
                title: '成员管理',
                path: Path.getMemberConfig(),
                pathIn: Path.isMemberConfig
            }
        ]
    }
];

export default NavConfig